import {AgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'

interface FetchWithAuthOptions {
  endpoint: string
}

export async function fetchWithAuth<T>({endpoint}: FetchWithAuthOptions): Promise<T> {
  const tokenProvider = new AgentSessionsTokenProvider()
  const token = await tokenProvider.getAuthToken()

  if (!token) {
    throw new Error('No token available')
  }

  const response = await fetch(endpoint, {
    headers: {
      Authorization: token.authorizationHeaderValue,
      Accept: 'application/json',
    },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch agent sessions')
  }

  const data = await response.json()
  return data
}
